var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.currentData.id && !_setup.betaMode
    ? _c(_setup.FormControlPlainText, {
        attrs: { value: _setup.title, "form-id": _vm.formId },
      })
    : _setup.show
    ? _c(_setup.FormControlTypeSelect, {
        attrs: {
          "current-data": _vm.currentData,
          field: _vm.field,
          "form-id": _vm.formId,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }